import React from 'react'
import PropTypes from 'prop-types'
import throttle from 'lodash/throttle'

export default class Chart extends React.Component {
  static propTypes = {
    height: PropTypes.number.isRequired,
    onMouseMove: PropTypes.func,
    onMouseLeave: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.onMouseMove = throttle(this.onMouseMove, 40, {leading: true, trailing: false})
  }

  componentWillUnmount() {
    this.onMouseMove.cancel()
  }

  render() {
    const {height} = this.props
    const style = {
      height
    }
    return (
      <div className='chart'>
        <svg
          className='chart_svg'
          style={style}
          onMouseMove={this.onMouseMove}
          onMouseLeave={this.onMouseLeave}
        >
          {this.props.children}
        </svg>
      </div>
    )
  }

  onMouseMove = e => {
    const {onMouseMove} = this.props

    if (onMouseMove) {
      const bounds = e.currentTarget.getBoundingClientRect()

      onMouseMove({
        mouseX: e.clientX - bounds.left,
        mouseY: e.clientY - bounds.top
      })
    }
  }

  onMouseLeave = e => {
    const {onMouseLeave} = this.props
    onMouseLeave && onMouseLeave(e)
  }
}



// WEBPACK FOOTER //
// ./client/components/Chart/Chart.js